import React from "react";
import { Alert } from "@heroui/react";

interface FormAlertProps {
  message: string;
  messageType: "success" | "danger" | "warning" | "info";
  className?: string;
}

const FormAlert: React.FC<FormAlertProps> = ({ 
  message, 
  messageType, 
  className = "" 
}) => {
  return (
    <Alert
      className={`mt-2 rounded-none ${className}`}
      color={messageType === "success" ? "success" : "danger"}
      variant="flat"
    >
      {message}
    </Alert>
  );
};

export default FormAlert;